/**
 * @module framework/directives/scroll-to
 */

import { Directive } from 'vue';

import { App } from '~/framework/vue';

const scrollToDirective: Directive<HTMLElement, string> = {
    // When the bound element is inserted into the DOM...
    mounted($element, binding) {
        // Focus the element
        if (binding.value) {
            try {
                const $target = document.querySelector<HTMLElement>(binding.value);
                if (!$target || !('offsetTop' in $target)) return;

                const top = Math.max(0, $target.offsetTop);
                $element.addEventListener('click', () => {
                    window.scrollTo({
                        top,
                        behavior: 'smooth',
                    });
                });
            } catch {
                console.info(`Could not scroll to "${binding.value}"`);
            }
        }
    },
};

// Register a global custom directive called `v-scroll-to`
export const scrollTo = (app: App) => {
    app.directive('scroll-to', scrollToDirective);
};
